import axios from 'axios';
import { get } from 'lodash';
import { logger, stats } from '@fiverr-private/obs';
import { TRANSLATION_TIMEOUT, OK_STATUS, STATS_PREFIX } from '../../constants';

export const NO_URL_ERROR = "translationUrl param wasn't provided, MT requests are pointing nowhere";
export const NO_CONTENT_ERROR = 'No Translation present';

export const translateReview = async ({ reviewText, sourceLanguage, sourceInfo, translationUrl }) => {
    const componentName = get(sourceInfo, 'component.name', 'unknown_component');

    try {
        if (!translationUrl) {
            stats.count(STATS_PREFIX, `missing_mt_route_key.${componentName}`);
            throw new Error(NO_URL_ERROR);
        }

        const { data } = await axios.post(
            translationUrl,
            { text: { reviewText }, sourceLanguage, sourceInfo },
            { timeout: TRANSLATION_TIMEOUT }
        );
        const { translatedBlob, status } = data;

        if (translatedBlob.reviewText === reviewText || status !== OK_STATUS) {
            throw new Error(NO_CONTENT_ERROR);
        }

        return translatedBlob.reviewText;
    } catch (error) {
        logger.error(error);
        throw error;
    }
};
